import { WssInvoiceEventTypes, WssInvoicePayload } from "src/modules/invoice/types/Wss";
import { resolveWssSessionEvent } from "src/modules/session/services/wssResolver";
import { WssSessionEventTypes, WssSessionPayload } from "src/modules/session/types/Wss";
import { resolveWssStationEvent } from "src/modules/station/services/wssResolver";
import { WssStationEventTypes, WssStationPayload } from "src/modules/station/types/Wss";
import { resolveWssSubscriptionEvent } from "src/modules/company/services/subscriptionWssResolver";
import { WssSubscriptionEventTypes, WssSubscriptionPayload } from "src/modules/company/types/Wss";
import { WssUserEventTypes, WssUserPayload } from "src/modules/user/types/Wss";

export type WssPayload =
    | WssStationPayload
    | WssSessionPayload
    | WssUserPayload
    | WssInvoicePayload
    | WssSubscriptionPayload;

export const resolveWssEvent = (wssPayload: WssPayload) => {
    // #1 station / evse status changes
    if (Object.values(WssStationEventTypes).includes(wssPayload.event as WssStationEventTypes)) {
        resolveWssStationEvent(wssPayload as WssStationPayload);
    }
    // #2 pdf created
    else if (
        Object.values(WssInvoiceEventTypes).includes(wssPayload.event as WssInvoiceEventTypes)
    ) {
        // do nothing
    }
    // #3 invitation
    else if (Object.values(WssUserEventTypes).includes(wssPayload.event as WssUserEventTypes)) {
        // do nothing
    }
    // #4 charging session status changes
    else if (
        Object.values(WssSessionEventTypes).includes(wssPayload.event as WssSessionEventTypes)
    ) {
        resolveWssSessionEvent(wssPayload as WssSessionPayload);
    }
    // #5 payment method / subscription activated
    else if (
        Object.values(WssSubscriptionEventTypes).includes(
            wssPayload.event as WssSubscriptionEventTypes
        )
    ) {
        resolveWssSubscriptionEvent(wssPayload as WssSubscriptionPayload);
    }
};
